import React from 'react';
import PropTypes from 'prop-types';
import { FeatureFlag } from 'site-modules/shared/components/feature-flag/feature-flag';
import { InsiderSection } from './insider-section';

export function DesktopInsiderSection({ use2027Theme = false }) {
  return (
    <FeatureFlag name="insider">
      <div className="d-flex align-items-center flex-no-shrink">
        <InsiderSection
          className="d-flex flex-row flex-nowrap justify-content-end ms-auto"
          isGlobalNavDesktop
          use2027Theme={use2027Theme}
        />
      </div>
    </FeatureFlag>
  );
}

DesktopInsiderSection.propTypes = {
  use2027Theme: PropTypes.bool,
};
